import { render } from "./update-dep-dialog.vue?vue&type=template&id=1d5345f2&scoped=true"
import script from "./update-dep-dialog.vue?vue&type=script&lang=js"
export * from "./update-dep-dialog.vue?vue&type=script&lang=js"

import "./update-dep-dialog.vue?vue&type=style&index=0&id=1d5345f2&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5345f2"]])

export default __exports__